import dayjs from 'dayjs';
import { useEffect } from 'react';

import { InstanceHealthBanner } from '@/components/InstanceHealthBanner';
import { LicenseExpiredBanner } from '@/components/LicenseExpiredBanner';
import { TenantUsageLimitsBanner } from '@/components/TenantUsageLimitsBanner';
import { LICENSE_EXPIRED_BANNER_KEY } from '@/constants/expiredBannerConstants';
import { useInfo } from '@/hooks/useInstanceFlag';
import { useTenantUsageLimits } from '@/hooks/useSwr';
import { isSelfHosted } from '@/utils/is-self-hosted';
import { useLocalStorageState } from '@/utils/use-local-storage-state';
import { localTime } from '@/utils/utc-time';

import { IncidentBanner } from './IncidentBanner';

export function PlatformInfoBanners() {
  const tenantUsageLimits = useTenantUsageLimits();

  const { data: instanceInfo } = useInfo();

  const [storedExpiredDateStr, setLicenseExpireTime] = useLocalStorageState<
    string | null
  >(LICENSE_EXPIRED_BANNER_KEY, null);

  useEffect(() => {
    setLicenseExpireTime(instanceInfo?.license_expiration_time ?? null);
  }, [instanceInfo?.license_expiration_time, setLicenseExpireTime]);

  const expireDateStr =
    instanceInfo?.license_expiration_time || storedExpiredDateStr;
  const expireDate = expireDateStr ? localTime(expireDateStr) : undefined;

  if (!isSelfHosted) {
    return (
      <>
        <IncidentBanner />
        {tenantUsageLimits?.data?.in_reject_set && (
          <TenantUsageLimitsBanner
            usageLimitsResponse={tenantUsageLimits.data}
          />
        )}
      </>
    );
  }

  if (expireDate) {
    const weekBeforeExpire = expireDate.subtract(7, 'day');
    if (weekBeforeExpire.unix() < dayjs().unix()) {
      return <LicenseExpiredBanner expireDate={expireDate} />;
    }
  }
  // Check if there's a health issue that requires showing the InstanceHealthBanner
  // This includes showing a blob storage warning banner if blob storage is not enabled.
  return <InstanceHealthBanner />;
}
